export default __webpack_public_path__ + "static/media/victim-support.b28639b5.jpeg";